 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		14: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		14: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"8d112edd5ec70ccb3086aae8b83eac6a4cb80019","3":"ed078b09b4f8dd07f0d1ef17a744fdefd322a548","4":"9987640489f9b6d4bd9f6cdb8e34cb082f80623a","5":"eed88938832242f7f240189e51d8b11eef1582b4","6":"91ed37fe19b1ef5ef4c4dab00292da164240b9dd","7":"46c219530fdde1c08d2d225e6a24fb660195b81a","8":"2918490ad3f1d53ef34d6a8b174c0c9f85013b00","9":"6f3f8f0e05a7650dc46cf3d89c80daf10e3a4e24","10":"3be44c1217a853aeea281a8925b45a81bfcd366f","11":"872ea9a4efde73b7c47704ff17db65f098870326","12":"component---src-pages-home-index-tsx","13":"e76280a594cdae87570b456dcdc91690c9f6263e","16":"component---src-pages-404-js","17":"component---src-pages-blog-index-js","18":"component---src-pages-bon-podarunkowy-index-tsx","19":"component---src-pages-bydgoszcz-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","20":"component---src-pages-cennik-index-tsx","21":"component---src-pages-gdansk-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","22":"component---src-pages-gdansk-usuwanie-znamion-pieprzykow-tsx","23":"component---src-pages-gdynia-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","24":"component---src-pages-gdynia-usuwanie-znamion-pieprzykow-tsx","25":"component---src-pages-index-js","26":"component---src-pages-katowice-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","27":"component---src-pages-katowice-usuwanie-znamion-pieprzykow-tsx","28":"component---src-pages-kontakt-index-tsx","29":"component---src-pages-krakow-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","30":"component---src-pages-krakow-usuwanie-znamion-pieprzykow-tsx","31":"component---src-pages-lodz-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","32":"component---src-pages-lodz-usuwanie-znamion-pieprzykow-tsx","33":"component---src-pages-nie-przekonuj-sie-na-wlasnej-skorze-index-tsx","34":"component---src-pages-nie-przekonuj-sie-na-wlasnej-skorze-o-kampanii-tsx","35":"component---src-pages-o-nas-index-tsx","36":"component---src-pages-poznan-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","37":"component---src-pages-poznan-konsultacje-onkologiczne-leczenie-czerniaka-tsx","38":"component---src-pages-poznan-laserowe-usuwanie-znamion-pieprzykow-wlokniakow-brodawek-kurzajek-tsx","39":"component---src-pages-poznan-usuwanie-znamion-pieprzykow-tsx","40":"component---src-pages-szczecin-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","41":"component---src-pages-szczecin-laserowe-usuwanie-znamion-pieprzykow-wlokniakow-brodawek-kurzajek-tsx","42":"component---src-pages-szczecin-usuwanie-znamion-pieprzykow-tsx","43":"component---src-pages-tags-index-tsx","44":"component---src-pages-warszawa-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","45":"component---src-pages-warszawa-laserowe-usuwanie-znamion-pieprzykow-wlokniakow-brodawek-kurzajek-tsx","46":"component---src-pages-warszawa-usuwanie-znamion-pieprzykow-tsx","47":"component---src-pages-wroclaw-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","48":"component---src-pages-wroclaw-laserowe-usuwanie-znamion-pieprzykow-wlokniakow-brodawek-kurzajek-tsx","49":"component---src-pages-wroclaw-usuwanie-znamion-pieprzykow-tsx","50":"component---src-pages-zywiec-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","51":"component---src-templates-article-js","52":"component---src-templates-blog-post-js","53":"component---src-templates-tags-js"}[chunkId]||chunkId) + "-" + {"0":"dc02e41c1449a877f5cf","1":"e9d24b1846c7d6eb9685","2":"d158260616e0896b19ea","3":"75fab48a3c435dc3d6b4","4":"5131d6dcb97bcd3485ba","5":"067505370021d03ea6b3","6":"fc03e6701de8b6df2dd4","7":"6fcbb6224ceb8b19a876","8":"30123576b0ac7ca9ca9e","9":"faa5e4f9bc534edf599f","10":"b0d3e95009ef1bdbf9c1","11":"cec6ffd18b438149d420","12":"212469486bb6c9f73859","13":"964515f54d81a6051f2a","16":"6b301b441b108d05062a","17":"e9e98651e0e9712c721b","18":"53fab10472254d148c45","19":"e37f95a1219cf03a9f8a","20":"eb302a773ce96cdf197f","21":"b7200d1be5272bb8e004","22":"35a27c9531503407336f","23":"8e73cbce5a544669fb8d","24":"8bafe706950d81bdd3cc","25":"650c26edc2995ee41765","26":"190b5930a561b5e70d13","27":"0bb14ac5b0f5bf1993bf","28":"f2902a7f923496ea064b","29":"f3796085519664fe1181","30":"869e6daa4f8c5ab6db44","31":"0133f4039ddfcae91860","32":"5e280d14994a6efabe53","33":"284b9fcafa368cbe45c0","34":"2d15436d18f324a72f32","35":"0f0f81b39589b6bc92cb","36":"b154f161d1486bb35807","37":"3eba1bf1b9d7707cc3c5","38":"022dc73200801b556f71","39":"496f55657144451b8604","40":"a88ba33466bc315ad936","41":"bc0435fd48bacc16982b","42":"d569aac23945c275b0d0","43":"2859f0fa457154eed03c","44":"f352b297f1029dbc0275","45":"07448cbb387fbdfc51c8","46":"785a8d1ad5aae44277b1","47":"1a05a8d7932fc87120f9","48":"97bddc390706a1ae7117","49":"81f177df71be0ca25892","50":"f57f8b8e6098fb86a5fa","51":"1d40ade2d7f6c5deb669","52":"7150fd4de0118d6f661e","53":"34b4d70d78a8a8289544","56":"fabc40671d4694c609ac"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"8d112edd5ec70ccb3086aae8b83eac6a4cb80019","3":"ed078b09b4f8dd07f0d1ef17a744fdefd322a548","4":"9987640489f9b6d4bd9f6cdb8e34cb082f80623a","5":"eed88938832242f7f240189e51d8b11eef1582b4","6":"91ed37fe19b1ef5ef4c4dab00292da164240b9dd","7":"46c219530fdde1c08d2d225e6a24fb660195b81a","8":"2918490ad3f1d53ef34d6a8b174c0c9f85013b00","9":"6f3f8f0e05a7650dc46cf3d89c80daf10e3a4e24","10":"3be44c1217a853aeea281a8925b45a81bfcd366f","11":"872ea9a4efde73b7c47704ff17db65f098870326","12":"component---src-pages-home-index-tsx","13":"e76280a594cdae87570b456dcdc91690c9f6263e","16":"component---src-pages-404-js","17":"component---src-pages-blog-index-js","18":"component---src-pages-bon-podarunkowy-index-tsx","19":"component---src-pages-bydgoszcz-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","20":"component---src-pages-cennik-index-tsx","21":"component---src-pages-gdansk-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","22":"component---src-pages-gdansk-usuwanie-znamion-pieprzykow-tsx","23":"component---src-pages-gdynia-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","24":"component---src-pages-gdynia-usuwanie-znamion-pieprzykow-tsx","25":"component---src-pages-index-js","26":"component---src-pages-katowice-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","27":"component---src-pages-katowice-usuwanie-znamion-pieprzykow-tsx","28":"component---src-pages-kontakt-index-tsx","29":"component---src-pages-krakow-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","30":"component---src-pages-krakow-usuwanie-znamion-pieprzykow-tsx","31":"component---src-pages-lodz-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","32":"component---src-pages-lodz-usuwanie-znamion-pieprzykow-tsx","33":"component---src-pages-nie-przekonuj-sie-na-wlasnej-skorze-index-tsx","34":"component---src-pages-nie-przekonuj-sie-na-wlasnej-skorze-o-kampanii-tsx","35":"component---src-pages-o-nas-index-tsx","36":"component---src-pages-poznan-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","37":"component---src-pages-poznan-konsultacje-onkologiczne-leczenie-czerniaka-tsx","38":"component---src-pages-poznan-laserowe-usuwanie-znamion-pieprzykow-wlokniakow-brodawek-kurzajek-tsx","39":"component---src-pages-poznan-usuwanie-znamion-pieprzykow-tsx","40":"component---src-pages-szczecin-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","41":"component---src-pages-szczecin-laserowe-usuwanie-znamion-pieprzykow-wlokniakow-brodawek-kurzajek-tsx","42":"component---src-pages-szczecin-usuwanie-znamion-pieprzykow-tsx","43":"component---src-pages-tags-index-tsx","44":"component---src-pages-warszawa-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","45":"component---src-pages-warszawa-laserowe-usuwanie-znamion-pieprzykow-wlokniakow-brodawek-kurzajek-tsx","46":"component---src-pages-warszawa-usuwanie-znamion-pieprzykow-tsx","47":"component---src-pages-wroclaw-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","48":"component---src-pages-wroclaw-laserowe-usuwanie-znamion-pieprzykow-wlokniakow-brodawek-kurzajek-tsx","49":"component---src-pages-wroclaw-usuwanie-znamion-pieprzykow-tsx","50":"component---src-pages-zywiec-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","51":"component---src-templates-article-js","52":"component---src-templates-blog-post-js","53":"component---src-templates-tags-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"f359bb5ebea148ae2fa2","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
